export class PipelineHistoryFieldChange {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "before",
            "baseName": "before",
            "type": "PipelineHistoryField",
            "format": ""
        },
        {
            "name": "after",
            "baseName": "after",
            "type": "PipelineHistoryField",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PipelineHistoryFieldChange.attributeTypeMap;
    }
    constructor() {
    }
}
